import React from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';

import BackButton from '../custom/BackButton';
import ActionIcon from '../custom/ActionIcon';
import { createdUpdatedInfo } from '../../utils';
import { IVisualReporting } from '../../globals/interfaces';
import { IDamageReportItem } from '../warehouse/damageReporting/utils';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    item: IDamageReportItem | undefined;
}

export default function NewModal ({
    modal,
    setModal,
    item
}: Props) {

    const toggle = () => setModal(!modal);

    if (!item) return null;

    return (
        <Modal isOpen={modal} toggle={toggle} size={'lg'}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>{item.awb_uld}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody className={'text-center'}>
                {
                    item.file_links.map((link, i) => (
                        <Img src={link} key={i} />
                    ))
                }
            </ModalBody>
        </Modal>
    );

}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const Img = styled.img`
    width: 300px;
    height: auto;
    padding-left: 10px;
    padding-bottom: 10px;
`;